module.exports = __webpack_public_path__ + "img/news-release.ea8f8f69.png";